import type { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import type { SupplierRequestListObjectType } from '@econtractor/types';
import SolarIcon from 'components/icons/SolarIcon';

interface RequestObjectChipProps {
    object: SupplierRequestListObjectType;
    onClick?: () => void;
    onRemove?: () => void;
}

const RequestObjectChip = ({ object, onClick, onRemove }: RequestObjectChipProps) => {
    const { t } = useTranslation(['common']);
    const title = object.objectName || object.clientName || `#${object.objectId}`;
    const isSale = Number(object.onlySale) > 0;
    const subtitle =
        object.objectName && object.clientName && object.objectName !== object.clientName
            ? object.clientName
            : '';

    const handleClick = (event: MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        onClick?.();
    };

    const handleRemove = (event: MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        event.stopPropagation();
        onRemove?.();
    };

    const className = `badge ${isSale ? 'bg-light-info' : 'bg-light-primary'} fs-12 d-inline-flex align-items-center gap-1 text-truncate mw-100 border-0 ${
        onClick ? 'cursor-pointer' : ''
    }`;

    const content = (
        <>
            <span className="text-truncate">{title}</span>
            {onRemove ? (
                <button
                    type="button"
                    className="btn btn-link p-0 lh-1 text-body"
                    title={t('buttons.clear')}
                    aria-label={t('buttons.clear')}
                    onClick={handleRemove}
                >
                    <SolarIcon name="x-lg" className="fs-12" />
                </button>
            ) : null}
        </>
    );

    if (onClick) {
        return (
            <button
                type="button"
                className={className}
                title={subtitle || title}
                onClick={handleClick}
            >
                {content}
            </button>
        );
    }

    return (
        <span className={className} title={subtitle || title}>
            {content}
        </span>
    );
};

export default RequestObjectChip;

